import {Injectable} from "@angular/core";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {CustomerAccountTraderDataLoadingService} from "./customer-account-trader-data-loading.service";
import {AccountTraderComponent} from "../../../crystal-clear/customer/account-trader/account-trader.component";
import TYPE = FormFieldConfig.TYPE;

@Injectable({
  providedIn: 'root'
})
export class CustomerAccountTraderFormConfigService {

  constructor(private readonly dataLoadingService: CustomerAccountTraderDataLoadingService) {
  }

  public loadConfig(component: AccountTraderComponent): FormFieldGroupConfig[] {

    return [
      {
        group: '',
        fields: [
          {
            field: 'owner',
            optionValue: 'text',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.dataLoadingService.owners,
            changed: event => {
              component.formRecord.owner = event.value;
              component.formRecord.customerName = undefined;
              const accountCode = component.formRecord.accountCode;
              component.formRecord.accountCode = undefined;
              this.dataLoadingService.filterCustomers(component.formRecord);
              this.dataLoadingService.filterAccounts(component.formRecord);
              if (accountCode) {
                const accountField = this.dataLoadingService.displayedAccounts.find(field => field.text === accountCode);
                if (accountField) {
                  component.formRecord.customerName = accountField.value.customerName;
                  component.formRecord.accountCode = accountField.value.code;
                }
              }
            }
          },
          {
            field: 'customerName',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            optionValue: 'text',
            options: () => this.dataLoadingService.displayedCustomers,
            changed: event => {
              component.formRecord.customerName = event.value;//this.customers.find(value => value.id ===event.value).text;
              const accountCode = component.formRecord.accountCode;
              component.formRecord.accountCode = undefined;
              this.dataLoadingService.filterAccounts(component.formRecord);
              if (accountCode) {
                const accountField = this.dataLoadingService.displayedAccounts.find(field => field.text === accountCode);
                if (accountField) {
                  component.formRecord.accountCode = accountField.value.code;
                }
              }
            }
          },
          {
            field: 'exchangeCode',
            icon: (id: string) => {
              if (this.dataLoadingService.exchangeCodes) {
                const exchField = this.dataLoadingService.exchangeCodes.find(exchange => exchange.value && exchange.value.code === id);
                if (exchField && exchField.value)
                  return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              }
              return 'fas fa-globe-europe';
            },
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            options: () => this.dataLoadingService.exchangeCodes,
            changed: event => {
              component.formRecord.exchangeCode = event.value;
              const accountCode = component.formRecord.accountCode;
              component.formRecord.accountCode = undefined;
              this.dataLoadingService.filterAccounts(component.formRecord);
              if (accountCode) {
                const accountField = this.dataLoadingService.displayedAccounts.find(field => field.text === accountCode);
                if (accountField) {
                  component.formRecord.accountCode = accountField.value.code;
                }
              }
            }
          },
          {
            field: 'contractList',
            column: 8,
            type: TYPE.TEXT
          },
          {
            field: 'contractListInclude',
            column: 4,
            type: TYPE.CHECKBOX
          },
          {
            field: 'accountCode',
            filter: true,
            column: 4,
            type: TYPE.DROPDOWN,
            optionValue: 'text',
            options: () => this.dataLoadingService.displayedAccounts,
          },
          {
            field: 'traderCode',
            required: true,
            filter: true,
            column: 4,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.dataLoadingService.traders,
          }]
      },
    ];
  }

}
